module.exports = __webpack_public_path__ + "static/media/tagluffa_demo.02feeb16.png";